import { render, staticRenderFns } from "./FormEmployeeDocuments.vue?vue&type=template&id=818e56ca"
import script from "./FormEmployeeDocuments.vue?vue&type=script&lang=js"
export * from "./FormEmployeeDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports